import * as core from '../../../../../../../core'

import { query } from './testing-table.query'

export const RESOURCE = {
  payload: {
    alias: 'testing.table',
    description:
      'Latest test and deployment result for each implementation pull request',
    name: 'Testing Table',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
